export default __webpack_public_path__ + "static/media/ellipseLeft.6d80cd22.svg";